import React from 'react';
import Layout from 'components/layout';
import SEO from 'components/seo';

// Component
import TextBlock from 'components/organisms/Blocks/TextBlock/TextBlock';
import ImageOverview from 'components/organisms/Blocks/ImageOverview/ImageOverview';
import Hero from 'components/molecules/Hero/Hero';

// Data
import ProjectenData from 'data/ProjectenData/ProjectenData.json';

const ProjectPage = () => (
  <Layout>
    <TextBlock
      data={ProjectenData.projectInfo}
    />
    <ImageOverview
      layerModifier="flatTop"
      data={ProjectenData.projectenOverview}
    />
    <Hero
      modifier="inPage"
      {...ProjectenData.inPageHero}
    />
  </Layout>
);
export default ProjectPage;

export const Head = () => (
  <SEO title="Projecten" />
);
